export default __webpack_public_path__ + "static/logo4-9449a8fce02f41facb185188f7b070d4.png";